// Aba ScontiPoste no painel do Manager (adesao ao canal)
const channelSellerDictEN = {
  settingsTabScontiPoste: "ScontiPoste",
  channelSellerTitle: "Sell on ScontiPoste",
  channelSellerIntro: "ScontiPoste is Poste Italiane's cashback program for Postepay and BancoPosta card holders. Once you join, your eligible products appear in the Extraconomy showcase for ScontiPoste.",
  channelSellerOnlyManagers: "Only Managers can sell on ScontiPoste.",
  channelSellerEligibleCount: "Eligible products: {count}",
  channelSellerListedCount: "Products in the showcase: {count}",
  channelSellerNoEligible: "No eligible products yet. See below what each product is missing.",
  channelSellerTerms: "Conditions",
  channelSellerTerm1: "On every ScontiPoste sale, {percent}% of the product value is deducted from you as ScontiPoste cashback. Poste Italiane credits it to the customer.",
  channelSellerTerm2: "The Extraconomy fee and the network commissions stay the same.",
  channelSellerTerm3: "You only sell products priced in euro, with free delivery paid by you or in-store pickup.",
  channelSellerTerm4: "You can leave at any time: your products disappear from the showcase right away and orders already received must still be fulfilled.",
  channelSellerTermsOutdated: "The ScontiPoste cashback changed to {percent}%. Your products are out of the showcase until you accept the new percentage.",
  channelSellerAcceptNew: "Accept {percent}%",
  channelSellerAccept: "I accept the conditions for selling on ScontiPoste",
  channelSellerMode: "What to show",
  channelSellerModeAll: "All eligible products, including the ones I add later",
  channelSellerModeSelected: "Only the products I choose",
  channelSellerJoin: "Join ScontiPoste",
  channelSellerJoined: "You have been on ScontiPoste since {date}, with {percent}% cashback.",
  channelSellerChannelInactive: "The ScontiPoste showcase is not open to the public yet: your products will appear when it opens.",
  channelSellerOpenShowcase: "Open the showcase",
  channelSellerProducts: "Your products",
  channelSellerSave: "Save products",
  channelSellerSaved: "Products saved",
  channelSellerLeave: "Leave ScontiPoste",
  channelSellerLeaveConfirm: "Your products disappear from the ScontiPoste showcase right away. Orders already received must still be fulfilled. Do you want to leave?",
  channelSellerLeft: "You left ScontiPoste",
  channelSellerJoinedToast: "You joined ScontiPoste",
  channelSellerAcceptRequired: "Accept the conditions to join.",
  channelReasonSELLER_TYPE: "Managers only",
  channelReasonNOT_PUBLISHED: "Not published",
  channelReasonSHIPPING_OPTION: "Paid delivery: use free delivery or in-store pickup",
  channelReasonCURRENCY: "Price not in euro",
  channelReasonDOWNLOADABLE: "Digital product",
  channelReasonSERVICE: "Service",
  channelReasonDROPSHIPPING: "Imported product (dropshipping)",
  channelReasonOUT_OF_STOCK: "Out of stock",
  channelError500435: "Only Managers can sell on ScontiPoste.",
  channelError500436: "Accept the conditions to join.",
  channelError500437: "You have not joined ScontiPoste yet.",
};

export default channelSellerDictEN;
